import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(localStorage.getItem("sb_lang") || "en");
  const [translations, setTranslations] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    setLoaded(false);
    api.get(`/translations`, { params: { lang: language } }).then(({ data }) => {
      if (active) {
        setTranslations(data);
        setLoaded(true);
      }
    }).catch(() => setLoaded(true));
    return () => { active = false; };
  }, [language]);

  const setLanguage = (lang) => {
    localStorage.setItem("sb_lang", lang);
    setLanguageState(lang);
  };

  const t = (key, fallback) => translations[key] || fallback || key;

  const field = (obj, base) => obj ? (obj[`${base}_${language}`] ?? obj[`${base}_fr`] ?? "") : "";

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, field, loaded }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
